import React, { useEffect } from "react";
import './Spandan.css'
import Spandan_Banner from './spandan_banner/Spandan_Banner'
import Sacred_Pulse from './sacred_pulse/Sacred_Pulse'
import Session_Type from './session_type/Session_Type'
import Healing_Banner from './healing_banner/Healing_Banner'
import What_Healing_Looks_Like from './what_healing_looks_like/What_Healing_Looks_Like'
import Register_Banner from './register_banner/Register_Banner'
import { GetSpandan } from '../../features/admin/spandan/Slice';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import parse from "html-react-parser";
const Spandan = () => {

  const dispatch = useDispatch();

  const all_spandan = useSelector((state) => state.spandan.all_spandan);

  useEffect(() => {
    dispatch(GetSpandan());
  }, [dispatch]);
  return (
    <section className='Spandan'>
      <Spandan_Banner all_spandan={all_spandan} />
      <Sacred_Pulse all_spandan={all_spandan} />
      <Session_Type />
      <Healing_Banner />
      <What_Healing_Looks_Like />
      <Register_Banner />
    </section>
  )
}

export default Spandan
